import { createFileRoute } from '@tanstack/react-router';

import { RedirectToParentPortalShare } from '~features/shared/redirect-to-parent-portal-share';

export const Route = createFileRoute('/public-event-share/$shareToken')({
  component: PublicEventShareRedirectPage,
});

function PublicEventShareRedirectPage() {
  const { shareToken } = Route.useParams();
  const studioId = Route.useSearch({
    select: (s) => (typeof s?.studioId === 'string' ? s.studioId : ''),
  });

  return (
    <RedirectToParentPortalShare
      path='public-event-share'
      shareToken={shareToken}
      studioId={studioId}
    />
  );
}
